var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThemeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0021 2.66663L19.5154 6.17996H25.8201V12.484L29.3334 15.9973L25.8201 19.516V25.82H19.5161L16.0027 29.3333L12.4841 25.82H6.18008V19.516L2.66675 15.998L6.18008 12.4846V6.17996H12.4841L16.0021 2.66663Z",
    stroke: "#FFFDF1",
    strokeWidth: 2.66667,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0002 11.3333C18.0002 16.6666 14.6668 17.3333 11.3335 17.3333C11.3335 19.9999 15.6668 22.6666 19.3335 19.9999C23.0002 17.3333 20.6668 11.3333 18.0002 11.3333Z",
    stroke: "#FFFDF1",
    strokeWidth: 2.66667,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThemeIcon);
export default __webpack_public_path__ + "static/media/themeIcon.ca3943adb46b53f9ff1d680ab5e670f0.svg";
export { ForwardRef as ReactComponent };